import { StreamActions } from '@hotwired/turbo'
import { Modal } from 'bootstrap'

/**
 * Custom Turbo Stream action: modal-close
 * Closes a Bootstrap modal
 *
 * Usage in Twig:
 * <turbo-stream action="modal-close" modal="modal-share"></turbo-stream>
 */
export default function init() {
    StreamActions['modal-close'] = function () {
        const modalId = this.getAttribute('modal')

        if (modalId) {
            const modalElement = document.getElementById(modalId)
            if (modalElement) {
                const modal = Modal.getInstance(modalElement)
                if (modal) {
                    modal.hide()
                }
            }
        }
    }
}
